// extracted by mini-css-extract-plugin
export var component = "story-module--component--2QwCz";
export var icon = "story-module--icon--2QwDq";
export var heading = "story-module--heading--1ukDx";
export var content = "story-module--content--mKBzk";
export var buttons = "story-module--buttons--2MyaV";